import { Injectable } from '@angular/core';
import { StoreConfig, EntityStore, EntityState } from '@datorama/akita';
import { Content } from '@23degrees/shared-code/models';

export interface FavoritesState extends EntityState<Content> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'favorites', idKey: '_id', resettable: true })
export class FavoritesStore extends EntityStore<FavoritesState, Content> {
  constructor() {
    super();
  }
}
